import { http } from "../http/Http";
import { AuditLogSource } from "../models/AuditLogSource";
import { ServiceResponse } from "../models/ServiceResponse";

export class AuditLogSourceService {

    getAuditLogSources = async (): Promise<ServiceResponse<AuditLogSource[]>> => {
        const { data } = await http.get<ServiceResponse<AuditLogSource[]>>("AuditLogSource/GetAll");
        return data;
    };

}